/**
* author: duxin
* date: 2020/4/3
* describe:
*/

<template>
    <div style="margin-top: -70px">
        <BannerChunk></BannerChunk>
        <div class="content">
            <AboutChunk></AboutChunk>
            <ServiceChunk></ServiceChunk>
            <NewsChunk></NewsChunk>
        </div>
    </div>
</template>

<script>
    import AboutChunk from "./chunks/about-me-chunk"
    import BannerChunk from "./chunks/banner-chunk.vue"
    import ServiceChunk from "./chunks/me-service-chunk.vue"
    import NewsChunk from "./chunks/me-news-chunk"

    export default {
        name: "home",
        components: {AboutChunk, BannerChunk, ServiceChunk, NewsChunk},
        methods: {
            onChange() {

            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../style/constant.less";

    .content {
        width: @page-width;
        margin: 0 auto;
        padding-bottom: 30px;
    }
    @media screen and (min-width: 320px) and (max-width: 480px) {
        .content {
            width:90%;
            line-height: 1.8;
        }
    }

</style>